module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_en-b8fd44e3895e2456f9c6323834ac8ec6.jpg";